import { render, staticRenderFns } from "./contact-widget.vue?vue&type=template&id=1a8956f7&scoped=true&"
import script from "./contact-widget.vue?vue&type=script&lang=js&"
export * from "./contact-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8956f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/gp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8956f7')) {
      api.createRecord('1a8956f7', component.options)
    } else {
      api.reload('1a8956f7', component.options)
    }
    module.hot.accept("./contact-widget.vue?vue&type=template&id=1a8956f7&scoped=true&", function () {
      api.rerender('1a8956f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "webpack/public-site-media-dunk/src/components/base/contact-widget.vue"
export default component.exports